export default {
  loading: true,
  data: {},
  saving: false,
};
